// extracted by mini-css-extract-plugin
module.exports = {"guidelines":"Guidelines","guidelinesColumns":"Guidelines-columns","guidelinesRows":"Guidelines-rows","guidelinesColumn":"Guidelines-column","guidelinesRow":"Guidelines-row"};